export * from './IconPrinterStroked';
